/**
 * TutorLivesHistoryScreen — « Mon historique de lives » (`tutor-lives-history`), ouvert par « Historique
 * des lives » de « Ma journée » et « Mes paiements ». Un fil : les lectures, le view-model, les gestes, la page.
 */
import React from "react"
import { useSelector } from "react-redux"

import { TutorLivesHistoryPage } from "../../../../../../design-system/tutor"
import { tutorLivesHistoryViewModel } from "../../../../view-models/tutor/Lives/tutorLivesHistoryViewModel"
import { useTutorLivesHistoryData } from "./useTutorLivesHistoryData"
import { useTutorLivesHistoryState } from "./useTutorLivesHistoryState"

export function TutorLivesHistoryScreen() {
    const vm = useSelector(tutorLivesHistoryViewModel)
    const data = useTutorLivesHistoryData()
    const gestures = useTutorLivesHistoryState()

    return (
        <TutorLivesHistoryPage
            occurrences={vm.occurrences}
            query={data.query}
            onChangeQuery={data.setQuery}
            loading={vm.loading}
            error={vm.error}
            onRetry={data.refresh}
            refreshing={vm.refreshing}
            onRefresh={data.refresh}
            loadingMore={vm.loadingMore}
            hasMore={data.hasMore}
            onLoadMore={data.loadMore}
            loadMoreError={vm.loadMoreError}
            onRetryLoadMore={data.loadMore}
            totalCount={data.totalCount}
            {...gestures}
            testID="tutor-lives-history"
        />
    )
}
